import { useState, useEffect, useCallback } from "react";
import { ReactComponent as Bars } from "./../../../images/icons/SVG/bars.svg";
import { ReactComponent as EyeDropperIcon } from "./../../../images/icons/SVG/eye_dropper.svg";
import ColorPicker, { useColorPicker } from "react-best-gradient-color-picker";
import { sortLeftRightTopBottom } from "../../../refractCommon/miro/sortLeftRightTopBottom";
import { RGBAStringToHex } from "./Colors_Utils";
import AnimateHeight from "react-animate-height";
import { generateUID } from "../../Utils/generateUID";
import ColorsInPaletteDragAndDrop from "./ColorsInPaletteDragAndDrop";
import { ColorExtractor } from "react-color-extractor";
import ToolTip from "../../../refractCommon/components/ToolTip";
import { convertObjectToData } from "../../../refractCommon/utils/convertObjectToData";
import ShadeGenerator from "shade-generator";
import debounce from "lodash/debounce";
import { getMiroUserId } from "../../../refractCommon/utils/useDataStoreMiro";

const miro = window.miro;
const EyeDropper = window.EyeDropper;

export default function Palette({
  item,
  dataPath,
  dispatch,
  boardSelection,
  dragHandleProps,
  userIsPro,
}) {
  const [color, setColor] = useState("#ffffff");
  const [nameFormValue, setNameFormValue] = useState(item.name);
  const [editMode, setEditMode] = useState(false);
  const [saveMode, setSaveMode] = useState(false);
  const [moreMode, setMoreMode] = useState(false);
  const [shadeTintMode, setShadeTintMode] = useState(false);
  const [idOfColorSelectedForPickerEdit, setIdOfColorSelectedForPickerEdit] =
    useState("");
  const [colorInPaletteSelectedFirstTime, setColorInPaletteSelectedFirstTime] =
    useState(false);
  const [exportColorListString, setExportColorListString] = useState("");
  const [proShine, setProShine] = useState(false);

  // SAVE OPTIONS
  // we'll need to understand where we get these defaults / how we set them per palette
  // its not entirely clear we need the 'save to board..'  TBD
  const [saveToBoard, setSaveToBoard] = useState(false);
  const [saveToCloud, setSaveToCloud] = useState(false);
  const [shareWithTeam, setShareWithTeam] = useState(false);

  // COLOR THE BOARD
  const [styleSelection, setStyleSelection] = useState({
    text: false,
    stroke: false,
    fill: true,
  });

  // CAPABILITY STATE
  // in
  const [canImportFromBoardSelection, setCanImportFromBoardSelection] =
    useState(false);
  const [canExtractFromImage, setCanExtractFromImage] = useState(false);
  // out
  const [
    canColorFillSomeSelectedItemsOnBoard,
    setCanColorFillSomeSelectedItemsOnBoard,
  ] = useState(false);
  const [
    canCloneSingleSelectedItemOnBoard,
    setCanCloneSingleSelectedItemOnBoard,
  ] = useState(false);

  // Import Colors from board
  const [importedBoardColors, setImportedBoardColors] = useState([]);

  // State for color extractor

  const [extractingFromImageMode, setExtractingFromImageMode] = useState(false);
  const [extractedColors, setExtractedColors] = useState([]);
  const [url, setUrl] = useState(
    "https://hips.hearstapps.com/harpersbazaaruk.cdnds.net/17/40/2048x1024/landscape-1506942420-los-angeles-skyline.jpg?resize=480:*"
  );
  const [imageItem, setImageItem] = useState({});
  const [colorCount, setColorCount] = useState(6);

  // Shades and Tints
  const [shadeTintCount, setShadeTintCount] = useState(10);
  const [shadeTintColors, setShadeTintColors] = useState([]);

  //// Using the colors
  const [useSingleOrAll, setUseSingleOrAll] = useState("all");
  ///

  const {
    setSolid,
    setPalette,
    currentLeft,
    selectedPoint,
    valueToHex,
    valueToHSL,
    hslArr,
    isPalette,
  } = useColorPicker(color, setColor);

  useEffect(() => {
    setNameFormValue(item.name);
  }, [item]);

  useEffect(() => {
    if (shadeTintMode) {
      getSetShadeTintColors();
    }
  }, [shadeTintMode, idOfColorSelectedForPickerEdit, shadeTintCount, color]);

  useEffect(() => {
    if (!colorInPaletteSelectedFirstTime) {
      if (item && item?._colors && item?._colors.length > 0) {
        setIdOfColorSelectedForPickerEdit(item._colors[0].id);
      }
      setColorInPaletteSelectedFirstTime(true);
    }
  }, [item]);

  useEffect(() => {
    createExportColorList();
  }, [saveMode, item]);

  useEffect(() => {
    checkSelectionAndSetCapabilityState();
  }, [boardSelection]);

  useEffect(() => {
    if (editMode) {
      if (
        item?._colors &&
        item._colors.length > 0 &&
        idOfColorSelectedForPickerEdit !== ""
      ) {
        if (getIndexOfColorById(idOfColorSelectedForPickerEdit) !== -1) {
          handleSetPaletteColorAndDotColor(
            "from-color-dot-to-picker",
            item._colors[getIndexOfColorById(idOfColorSelectedForPickerEdit)]
              .color
          );
        }
      }
    }
  }, [editMode, idOfColorSelectedForPickerEdit, item._colors]);

  //   SET STATE ON UPDATED SELECTION
  async function checkSelectionAndSetCapabilityState() {
    let selection = await miro.board.getSelection();
    if (selection.length < 1) {
      setCanColorFillSomeSelectedItemsOnBoard(false);
      setCanExtractFromImage(false);
      setCanImportFromBoardSelection(false);
      setCanCloneSingleSelectedItemOnBoard(false);
      return;
    }
    if (selection.length === 1) {
      if (selection[0].type === "image") {
        setCanColorFillSomeSelectedItemsOnBoard(false);
        setCanExtractFromImage(true);
        setCanImportFromBoardSelection(false);
        setCanCloneSingleSelectedItemOnBoard(false);
        ingestImage();
      } else if (selection[0].type === "shape") {
        setCanColorFillSomeSelectedItemsOnBoard(true);
        setCanExtractFromImage(false);
        setCanImportFromBoardSelection(true);
        setCanCloneSingleSelectedItemOnBoard(true);
      }
    }
    if (selection.length > 1) {
      let types = selection.map((item) => item.type);
      if (types.includes("shape")) {
        setCanColorFillSomeSelectedItemsOnBoard(true);
        setCanExtractFromImage(false);
        setCanImportFromBoardSelection(true);
        setCanCloneSingleSelectedItemOnBoard(false);
      }
    }
  }

  function switchUseSingleOrAll(value) {
    setUseSingleOrAll(value);
  }

  /// PALETTE S T U F F        ////////////////////////////

  // async function handleSetPaletteName(value) {
  //   await dispatch({
  //     path: dataPath + "." + item.id + ".name",
  //     data: value,
  //   });
  // }

  const handleNameChange = (e) => {
    const { value } = e.target;
    setNameFormValue(value);
    handleSaveName(value);
  };

  const handleSaveName = useCallback(
    debounce(async (value) => {
      await dispatch({
        path: dataPath + "." + item.id + ".name",
        data: value,
      });
    }, 500),
    []
  );

  async function handleRemoveItem(item) {
    await dispatch({
      path: [dataPath, item.id],
      remove: true,
    });
  }

  async function duplicateItem() {
    const newItem = JSON.parse(JSON.stringify(item));
    newItem.id = generateUID();
    newItem.name = "Copy of " + newItem.name;
    await dispatch([
      {
        path: [dataPath, newItem.id],
        data: convertObjectToData(newItem),
      },
      {
        path: [dataPath, "_order"],
        data: newItem.id,
        index: 0,
      },
    ]);
  }

  /// COLOR STUFF
  async function addColor(flag, newColorToAdd) {
    let newColor = {};
    let newId = generateUID();
    if (flag === "new") {
      newColor = {
        color: color,
        id: newId,
      };
      const message = [
        {
          path: [dataPath, item.id, "_colors", newId],
          data: newColor,
        },
        {
          path: [dataPath, item.id, "_colors", "_order"],
          data: newId,
          index: "end",
        },
      ];
      await dispatch(message);

      setIdOfColorSelectedForPickerEdit(newColor.id);
      if (editMode === false) {
        setEditMode(true);
      }
    } else if (flag === "from-eyedropper") {
      newColor = {
        color: newColorToAdd,
        id: newId,
      };
      const message = [
        {
          path: [dataPath, item.id, "_colors", newId],
          data: newColor,
        },
        {
          path: [dataPath, item.id, "_colors", "_order"],
          data: newId,
          index: "end",
        },
      ];
      await dispatch(message);

      setIdOfColorSelectedForPickerEdit(newColor.id);
      // if (editMode === false) {
      //   setEditMode(true);
      // }
    }
  }

  async function removeColor() {
    let paletteToUpdate = { ...item };
    if (item._colors.length > 1) {
      if (idOfColorSelectedForPickerEdit !== "") {
        let indexToRemove = getIndexOfColorById(idOfColorSelectedForPickerEdit);

        let newItemToBeSelectedIndex;
        if (indexToRemove === paletteToUpdate._colors.length - 1) {
          newItemToBeSelectedIndex = indexToRemove - 1;
        } else {
          newItemToBeSelectedIndex = indexToRemove + 1;
        }

        let newItemIdToBeSelected =
          paletteToUpdate._colors[newItemToBeSelectedIndex].id;

        setIdOfColorSelectedForPickerEdit(newItemIdToBeSelected);
      }
    }
    await dispatch({
      path: [dataPath, item.id, "_colors", idOfColorSelectedForPickerEdit],
      remove: true,
    });
  }

  function handleSetPaletteColorAndDotColor(flag, updateColor) {
    if (flag === "from-color-dot-to-picker") {
      setColor(updateColor);
    } else if (flag === "from-eyedropper") {
      console.log(updateColor);
      handleSetDotColorFromPalette(updateColor);
    }
  }

  async function handleSetDotColorFromPalette(value) {
    let hexColor;
    if (Array.from(value)[0] === "#") {
      hexColor = value;
    } else {
      hexColor = RGBAStringToHex(value.toLowerCase());
    }
    if (
      item?._colors &&
      item._colors.length > 0 &&
      idOfColorSelectedForPickerEdit !== ""
    ) {
      await dispatch({
        path: [
          dataPath,
          item.id,
          "_colors",
          idOfColorSelectedForPickerEdit,
          "color",
        ],
        data: hexColor,
      });
    }

    setColor(hexColor);
  }

  function updateColorClicked(colorIdClicked) {
    if (colorIdClicked === idOfColorSelectedForPickerEdit) {
      // toggle open/close the color picker
      if (dispatch) {
        setEditMode(!editMode);
      }
    } else {
      setIdOfColorSelectedForPickerEdit(colorIdClicked);
    }
  }

  function getIndexOfColorById(id) {
    const index = item._colors.findIndex((col) => col.id === id);
    return index;
  }

  // PALETTE FILL ACTION
  function fillItemsWithPalette(pal) { }

  function handleKeyPress(e) {
    if (e.keyCode === 13) {
      e.target.blur();
      //Write you validation logic here
    }
  }

  function createExportColorList() {
    let newList = item._colors.map((color) => color.color);
    if (newList.length === 0) {
      setExportColorListString("");
    } else if (newList.length === 0) {
      setExportColorListString(newList[0]);
    } else {
      let newListString = newList.join("\n");
      setExportColorListString(newListString);
    }
  }

  //  COLOR EXTRACTOR
  function handleStyleButtonClick(flag) {
    let newStyleSelection = { ...styleSelection };

    switch (flag) {
      case "text":
        newStyleSelection.text = !newStyleSelection.text;
        setStyleSelection(newStyleSelection);
        break;
      case "stroke":
        newStyleSelection.stroke = !newStyleSelection.stroke;
        setStyleSelection(newStyleSelection);
        break;
      case "fill":
        newStyleSelection.fill = !newStyleSelection.fill;
        setStyleSelection(newStyleSelection);
        break;

      default:
        setStyleSelection(newStyleSelection);
    }
  }

  // IMPORT FROM BOARD
  async function importColorsFromBoard() {
    // lets just start with 'shapes' for now.
    let viableItemTypes = ["shape"];
    let selectionArray = await miro.board.getSelection();
    let filteredArray = selectionArray.filter((item) =>
      viableItemTypes.includes(item.type)
    );
    let importedColorArray;
    if (filteredArray.length > 0) {
      importedColorArray = filteredArray.map((item) => item.style.fillColor);
    }
    setImportedBoardColors(importedColorArray);

    // lets add them to the palette auto for now.
    let paletteToUpdate = { ...item };

    const colorsDict = {};
    const colorIds = [];
    importedColorArray.reverse().forEach((color) => {
      let uid = generateUID();
      let newColor = {
        color: color,
        id: uid,
      };
      colorsDict[uid] = newColor;
      colorIds.unshift(uid);
      paletteToUpdate._colors.unshift(newColor);
    });
    await dispatch({
      path: [dataPath, item.id, "_colors"],
      data: colorsDict,
      ids: colorIds,
      index: "end",
    });
    setIdOfColorSelectedForPickerEdit(paletteToUpdate._colors[0].id);
  }

  // EXTRACT FROM IMAGE

  async function extractFromImage() {
    let imageUrl = await ingestImage();
  }

  async function ingestImage() {
    let selection = await miro.board.getSelection();
    let imageUrl;
    let newImageItem;
    // let imageId;
    if (selection.length === 1 && selection[0].type === "image") {
      newImageItem = selection[0];
      setImageItem(newImageItem);
      // imageId = newImageItem.id;

      if (newImageItem?.url && newImageItem.url !== "") {
        imageUrl = newImageItem.url;
        setUrl(newImageItem.url);
      }
    }
    return imageUrl;
  }

  function handleExtractColors(colors) {
    setExtractedColors(colors);
  }

  async function extractColor() {
    //  A SECTION READY TO GO>.. NEEDS CORS PROOF BACK END REQUEST TO MIRO SERVER FOR FINAL IMAGE URL REQUEST
    // if (selection.length === 1 && selection[0].type === "image") {
    //   imageId = selection[0].id;
    // }
    // let miroBoardInfo = await miro.board.getInfo();
    // let boardId = miroBoardInfo.id;
    // Get the JWT signed with your app client secret.
    // const token = await miro.board.getIdToken();
    // const options = {
    //   method: "GET",
    //   headers: {
    //     accept: "application/json",
    //     Authorization: `Bearer ${token}`,
    //   },
    // };
    // let imageData = await fetch(
    //   `https://api.miro.com/v2/boards/${boardId}/images/${imageId}`,
    //   options
    // )
    //   .then((response) => response.json())
    //   .catch((err) => console.error(err));
    // Pass the JWT with each request from your app to your backend services.
    // const response2 = await fetch(
    //   `http://api.miro.com/v2/boards/${boardId}/resources/images/${imageId}?format=preview&redirect=true`,
    //   {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    ///////////// END IMAGE URL ATTEMPT
  }

  async function placeSwatchesUnderImage() {
    ///
    // place the swatches under the image
    if (extractedColors.length > 0) {
      // const imageOriginX = imageItem.x;
      // const imageOriginY = imageItem.y;
      const imageBottomLeft_X = imageItem.x - imageItem.width * 0.5;
      const imageBottomLeft_Y = imageItem.y + imageItem.height * 0.5;

      const vertBufferFromImage = imageItem.height * 0.1;
      const horizontalBufferScale = 0.1;
      const widthOfSwatch =
        imageItem.width /
        (colorCount + (colorCount - 1) * horizontalBufferScale);

      for (let i = 0; i < colorCount; i++) {
        let swatchItem = miro.board.createShape({
          content: `<p>${extractedColors[i]}</p>`,
          shape: "circle",
          style: {
            fillColor: extractedColors[i], // Default color: transparent (no fill)
            fontFamily: "arial", // Default font type for the text
            fontSize: widthOfSwatch * 0.08, // Default font size in dp for the text
            textAlign: "center", // Default alignment: center
            textAlignVertical: "middle", // Default alignment: middle
          },
          x:
            imageBottomLeft_X +
            widthOfSwatch * i +
            widthOfSwatch * i * horizontalBufferScale +
            0.5 * widthOfSwatch,
          y: imageBottomLeft_Y + vertBufferFromImage + 0.5 * widthOfSwatch, // Default value: center of the board
          width: widthOfSwatch,
          height: widthOfSwatch,
        });
      }
    }
  }

  async function addExtractedColorsToPalette() {
    // lets add them to the palette auto for now.
    let paletteToUpdate = { ...item };

    let extractedColorsCopy = [...extractedColors];

    if (extractedColorsCopy && extractedColorsCopy.length > 0) {
      const colorsDict = {};
      const colorIds = [];
      extractedColorsCopy.reverse().forEach((color) => {
        let uid = generateUID();
        let newColor = {
          color: color,
          id: uid,
        };
        colorsDict[uid] = newColor;
        colorIds.unshift(uid);
        paletteToUpdate._colors.unshift(newColor);
      });
      await dispatch({
        path: [dataPath, item.id, "_colors"],
        data: colorsDict,
        ids: colorIds,
        index: "end",
      });
      setIdOfColorSelectedForPickerEdit(paletteToUpdate._colors[0].id);
    }
  }

  // GET SHADE TINTS
  function getSetShadeTintColors() {
    let currentColor =
      item._colors[getIndexOfColorById(idOfColorSelectedForPickerEdit)].color;
    const config1 = {
      10: 0.9,
      20: 0.8,
      30: 0.7,
      40: 0.6,
      50: 0.5,
      60: 0.4,
      70: 0.3,
      80: 0.2,
      90: 0.1,
      100: 0,
      200: 0.9,
      300: 0.8,
      400: 0.7,
      500: 0.6,
      600: 0.5,
      700: 0.4,
      800: 0.3,
      900: 0.2,
      1000: 0.1,
    };
    const colorMap = ShadeGenerator.hue(currentColor)
      .config(config1)
      .shadesMap("hex");
    let newShadeTintColorArray = [];
    Object.keys(colorMap).forEach(function (key, index) {
      if (key !== "100") {
        newShadeTintColorArray.push(colorMap[key]);
      }
    });
    setShadeTintColors(newShadeTintColorArray);
  }

  async function addShadeTintColorsToPalette() {
    // lets add them to the palette auto for now.
    let paletteToUpdate = { ...item };

    let shadeTintColorsCopy = [...shadeTintColors];

    if (shadeTintColorsCopy && shadeTintColorsCopy.length > 0) {
      const colorsDict = {};
      const colorIds = [];
      shadeTintColorsCopy.reverse().forEach((color) => {
        let uid = generateUID();
        let newColor = {
          color: color,
          id: uid,
        };
        colorsDict[uid] = newColor;
        colorIds.unshift(uid);
        paletteToUpdate._colors.unshift(newColor);
      });
      await dispatch({
        path: [dataPath, item.id, "_colors"],
        data: colorsDict,
        ids: colorIds,
        index: "end",
      });
      setIdOfColorSelectedForPickerEdit(paletteToUpdate._colors[0].id);
    }
  }

  // USE THE COLORS ON THE BOARD
  async function addNewItemWithColor(flag) {
    let viewport = await miro.board.viewport.get();
    // let selection = await miro.board.getSelection();
    // let validItemTypes = ["shape"];
    // let filteredSelection = selection.filter((item) =>
    //   validItemTypes.includes(item.type)
    // );
    let startPointX = viewport.width * 0.4 + viewport.x;
    let startPointY = viewport.height / 2 + viewport.y;
    let sizeOfSquare = viewport.width / 20;
    let horizontalBufferScale = 0.1;

    if (flag === "all") {
      for (let i = 0; i < item._colors.length; i++) {
        let swatchItem = miro.board.createShape({
          content: "",
          shape: "rectangle",
          style: {
            fillColor: item._colors[i].color, // Default color: transparent (no fill)
          },
          x:
            startPointX +
            sizeOfSquare * i +
            sizeOfSquare * i * horizontalBufferScale,
          y: startPointY, // Default value: center of the board
          width: sizeOfSquare,
          height: sizeOfSquare,
        });
      }
    } else if (flag === "single") {
      let color =
        item._colors[getIndexOfColorById(idOfColorSelectedForPickerEdit)].color;
      let swatchItem = await miro.board.createShape({
        shape: "rectangle",
        style: {
          fillColor: color,
        },
        x: startPointX,
        y: startPointY,
        width: sizeOfSquare,
        height: sizeOfSquare,
      });
    }
  }
  async function fillItemsWithColor(flag) {
    let viewport = await miro.board.viewport.get();
    let selection = await miro.board.getSelection();
    let validItemTypes = ["shape"];
    let filteredSelection = selection.filter((item) =>
      validItemTypes.includes(item.type)
    );

    let sortedSelection = sortLeftRightTopBottom(filteredSelection);

    if (flag === "all") {
      let minArrayLength = Math.min(
        sortedSelection.length,
        item._colors.length
      );
      for (let i = 0; i < minArrayLength; i++) {
        let itemToUpdate = sortedSelection[i];
        itemToUpdate.style.fillColor = item._colors[i].color;
        itemToUpdate.sync();
      }
    } else if (flag === "single") {
      let colorToFillWith =
        item._colors[getIndexOfColorById(idOfColorSelectedForPickerEdit)].color;
      for (let i = 0; i < sortedSelection.length; i++) {
        sortedSelection[i].style.fillColor = colorToFillWith;
        sortedSelection[i].sync();
      }
    }
  }
  async function duplicateItemAndFillWithColor(flag) {
    let viewport = await miro.board.viewport.get();
    let selection = await miro.board.getSelection();
    let validItemTypes = ["shape"];
    let filteredSelection = selection.filter((item) =>
      validItemTypes.includes(item.type)
    );
    let sortedSelection = sortLeftRightTopBottom(filteredSelection);
    let itemToDuplicateAndRecolor = sortedSelection[0];

    let startPointX = itemToDuplicateAndRecolor.x;
    let startPointY =
      itemToDuplicateAndRecolor.y + 1.5 * itemToDuplicateAndRecolor.height;
    let sizeOfSquare = viewport.width / 20;
    let horizontalBufferScale = 0.1;

    if (flag === "all") {
      for (let i = 0; i < item._colors.length; i++) {
        let itemToBuild = { ...itemToDuplicateAndRecolor };
        itemToBuild.style.fillColor = item._colors[i].color;
        itemToBuild.x =
          startPointX +
          itemToBuild.width * i +
          itemToBuild.width * i * horizontalBufferScale;
        itemToBuild.y = startPointY; // Default value: center of the board
        let clonedItem = await miro.board.createShape(itemToBuild);
      }
    } else if (flag === "single") {
      let color =
        item._colors[getIndexOfColorById(idOfColorSelectedForPickerEdit)].color;
      let itemToBuild = { ...itemToDuplicateAndRecolor };
      itemToBuild.style.fillColor = color;
      itemToBuild.x = startPointX;
      itemToBuild.y = startPointY; // Default value: center of the board
      let clonedItem = await miro.board.createShape(itemToBuild);
    }
  }

  async function useEyeDropper() {
    if (!window.EyeDropper) {
      alert("Your browser does not support the EyeDropper API");
      return;
    }
    const eyeDropper = new EyeDropper();
    eyeDropper
      .open()
      .then((result) => {
        if (editMode) {
          handleSetPaletteColorAndDotColor("from-eyedropper", result.sRGBHex);
        } else {
          addColor("from-eyedropper", result.sRGBHex);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  return (
    <div className="cs1 ce12 grid tool-container a-bit-of-shadow">
      {!dispatch ? (
        <>
          <div
            className="cs1 pl-6"
            style={{ display: "none" }}
            {...dragHandleProps}></div>
          <div className="cs1 ce12">{nameFormValue}</div>
        </>
      ) : (
        <>
          <div className="cs1 pl-6" {...dragHandleProps}>
            <Bars style={{ fill: "currentColor" }} />
          </div>
          {/* <div className="cs2 ce8 p-medium">{palette.name}</div> */}
          <div className="cs2 ce8" style={{ width: "194px !important" }}>
            <input
              className="input input-small mb-0 mr--8"
              type="text"
              placeholder="Clever Palette Name"
              id="Palette Name"
              value={nameFormValue}
              onChange={handleNameChange}
            />
          </div>

          <div className="cs9 ce12 grid">
            <ToolTip
              placement={"top-end"}
              toolTipContent={
                <>
                  Export/save/share palette. <br></br>(PRO: coming soon)
                </>
              }>
              <div className="cs1">
                <button
                  disabled={true}
                  onClick={() => setSaveMode(!saveMode)}
                  className={
                    "button button-tertiary button-small smaller-button mb-0 mt-0 ml-4 mr-0  pl-0 pr-0 cs1" +
                    " " +
                    (saveMode ? "button-selected" : "")
                  }
                  type="button">
                  <span className="icon-export mb-12"></span>
                </button>
              </div>
            </ToolTip>
            <ToolTip placement={"top-end"} toolTipContent={"Duplicate palette"}>
              <button
                onClick={() => duplicateItem(item)}
                className="button button-tertiary button-small smaller-button mb-0 mt-0 mr-4 ml-4 pl-0 pr-0 cs2 "
                type="button">
                <span className="icon-duplicate mb-12"></span>
              </button>
            </ToolTip>
            <ToolTip placement={"top-end"} toolTipContent={"Delete palette"}>
              <button
                onClick={() => handleRemoveItem(item)}
                className="button button-tertiary button-small smaller-button mb-0 mt-0 mr-0 ml-0 pl-0 pr-0 cs3 "
                type="button">
                <span className="icon-trash mb-8"></span>
              </button>
            </ToolTip>
          </div>

          <hr className="mt-0 mb-0 cs1 ce12" />

          <AnimateHeight
            id="save-and-export-options-panel"
            duration={1000}
            height={saveMode ? "auto" : 0}
            style={{ width: "334px" }}
            className="cs1 ce12"
            easing="cubic-bezier(0, 1, 0.5, 1)">
            <div className="cs1 ce12 grid mt-4 mb-16">
              <div className="cs1 ce12 grid">
                {/* <hr className="cs1 ce12 mt-0 mb-0" /> */}
                {/* <h3 className="cs1 ce12 p-large mt-0 mb-0">
            <b>Save and Export:</b>
          </h3> */}
                <div className="cs1 icon icon-public mt-0 mb-0 mr-4"></div>
                <p className="cs2 ce12 p-medium mt-8 mb-8">
                  <b>Access this palette from...</b>
                </p>

                <div className="cs1 ce12 grid mt-0 mb-16">
                  {/* <div className="p-medium cs1 ce12 mt-0 mb-4">Who can access:</div> */}

                  <div className="cs1 ce8 grid">
                    <label className="cs1 ce12 grid toggle mt-0 mb-0">
                      <input
                        type="checkbox"
                        defaultChecked={true}
                        tabIndex="0"
                      />
                      <span className="cs2 ce5">
                        Only this board <i>-(default)</i>
                      </span>
                    </label>
                  </div>
                  <p className="ce12  p-small mb-0 mt-0 inline-basic-plan-tag ">
                    Basic
                  </p>
                  <div
                    onMouseEnter={() => {
                      if (!userIsPro) {
                        setProShine(true);
                      }
                    }}
                    onMouseLeave={() => {
                      if (!userIsPro) {
                        setProShine(false);
                      }
                    }}
                    className={"cs1 ce12 grid mb-8"}>
                    <label className="cs1 ce8 toggle mt-0 mb-0">
                      <input
                        className={userIsPro ? "" : "pro-restricted-no-click"}
                        type="checkbox"
                        tabIndex="0"
                        value={saveToCloud}
                        onChange={() => setSaveToCloud(!saveToCloud)}
                        disabled={userIsPro ? false : true}
                      />
                      <span>Any board</span>
                    </label>

                    <p
                      onClick={async () => {
                        const stripeUrl =
                          "https://buy.stripe.com/test_5kAaIg3YRfFw4246oo?client_reference_id=" +
                          (await getMiroUserId());
                        window.open(stripeUrl, "_blank");
                      }}
                      className={
                        "ce12 p-small mb-0 mt-0 inline-pro-plan-upgrade-tag" +
                        " " +
                        (proShine ? "pro-shine" : "")
                      }>
                      Pro
                    </p>
                  </div>
                  <div className="cs1 icon icon-team mt-8 mb-0 mr-4"></div>
                  <p className="cs2 ce12 p-medium mt-8 mb-0">
                    <b>Allow team access?</b>
                  </p>
                  <div className="cs1 ce7">
                    <label className="toggle mt-0 mb-0">
                      <input
                        value={shareWithTeam}
                        onChange={() => setShareWithTeam(!shareWithTeam)}
                        type="checkbox"
                        tabIndex="0"
                      />
                      <span>Share with team</span>
                    </label>
                  </div>
                  <p className="cs12 p-small mb-0 mt-0 inline-basic-plan-tag">
                    Basic
                  </p>

                  <button
                    style={{ alignSelf: "end !important" }}
                    type="button"
                    className="cs1 ce12 button button-small button-primary mt-16 mr-0">
                    Save Palette
                  </button>
                </div>
              </div>
              <div className="cs1 ce12 grid">
                <div className="icon icon-card-list cs1"></div>
                <p className="cs2 ce12 p-medium mt-8 mb-8">
                  <b>
                    Copy <i>Hex</i> Color List:
                  </b>
                </p>
                <div className="cs1 ce6 form-group mb-0">
                  <textarea
                    style={{ height: "100px" }}
                    className="textarea textarea-small"
                    id="textarea-readonly"
                    readOnly
                    defaultValue={exportColorListString}></textarea>
                </div>
              </div>
            </div>
            <hr className="cs1 ce12 mt-0 mb-16" />
          </AnimateHeight>

          <div className="cs1 ce12 grid mb-0">
            <div className="cs1 ce5 grid mr-0 ml-0 pr-8 border-right">
              <p className="cs1 ce12 mb--6 mt--8 p-small">Single color </p>
              <ToolTip placement={"top-start"} toolTipContent={"Add color"}>
                <button
                  onClick={() => addColor("new")}
                  className="cs1 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0"
                  type="button">
                  <span className="icon-plus smaller-button-icon"></span>
                </button>
              </ToolTip>
              <ToolTip
                placement={"top"}
                toolTipContent={"Eye Dropper- select a spot on the board."}>
                <div className="cs2">
                  <button
                    disabled={false}
                    onClick={useEyeDropper}
                    className="button button-tertiary smaller-button button-small mb-0 mt-0  pl-0 pr-0 cs3 "
                    type="button">
                    <div className="mb-12 pb-2 pr-2 pl-2 svg-icon-container">
                      <EyeDropperIcon className="mb-2 mr-2 ml-2 svg-icon" />
                    </div>
                  </button>
                </div>
              </ToolTip>
              <ToolTip placement={"top-start"} toolTipContent={"Edit Mode"}>
                <button
                  onClick={() => setEditMode(!editMode)}
                  className={
                    "cs3 button button-tertiary button-small smaller-button mb-0 mt-0 mr-0 ml-2 pl-0 pr-0 pt-0 pb-4" +
                    " " +
                    (editMode ? " button-selected" : "")
                  }
                  type="button">
                  <span className="icon-edit smaller-button-icon"></span>
                </button>
              </ToolTip>
              <ToolTip placement={"top"} toolTipContent={"Remove color"}>
                <button
                  onClick={() => removeColor()}
                  className="cs4 button button-tertiary smaller-button button-small mb-0 mt-0 mr-4 ml-2 pl-0 pr-0"
                  type="button">
                  <span className="icon-trash smaller-button mb-12"></span>
                </button>
              </ToolTip>
            </div>
            <div className="cs6 ce9 grid mr-0 pr-0 ">
              <p className="cs1 ce8 mb--6 mt--8 p-small">Many colors </p>

              <ToolTip
                placement={"top"}
                toolTipContent={"Extract from board selection (shapes)"}>
                <div className="cs1">
                  <button
                    onClick={importColorsFromBoard}
                    disabled={!canImportFromBoardSelection}
                    className=" button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0"
                    type="button">
                    <span className="icon-cursor-user smaller-button-icon"></span>
                  </button>
                </div>
              </ToolTip>

              <ToolTip
                placement={"top"}
                toolTipContent={"Extract From Image: (PRO: coming soon)"}>
                <div className="cs2">
                  <button
                    onClick={() =>
                      setExtractingFromImageMode(!extractingFromImageMode)
                    }
                    // disabled={!canExtractFromImage}
                    disabled={true}
                    className={
                      "button button-tertiary button-small smaller-button mb-0 mt-0 mr-8 ml-4 pl-0 pr-0 pt-0 pb-4" +
                      " " +
                      (extractingFromImageMode ? " button-selected" : "")
                    }
                    type="button">
                    <span className="icon-image smaller-button-icon"></span>
                  </button>
                </div>
              </ToolTip>
              <ToolTip
                placement={"top"}
                toolTipContent={"Generate Shades/Tints: (PRO: coming soon)"}>
                <div className="cs3">
                  <button
                    disabled={false}
                    onClick={() => setShadeTintMode(!shadeTintMode)}
                    className="button button-tertiary smaller-button button-small mb-0 mt-0 mr-4 ml--6 pl-0 pr-0 cs3  "
                    type="button">
                    <span className="icon-analytics smaller-button mb-12"></span>
                  </button>
                </div>
              </ToolTip>
            </div>
          </div>
        </>
      )}
      <hr className="mt-0 mb-0 cs1 ce12" />
      <div className="cs1 ce12 grid mb-0">
        <div id="color-in-palette" className="cs1 ce12 mb-0">
          <ColorsInPaletteDragAndDrop
            palette={item}
            dataPath={dataPath}
            dispatch={dispatch}
            updateColorClicked={updateColorClicked}
            idOfColorSelectedForPickerEdit={idOfColorSelectedForPickerEdit}
          />
        </div>
      </div>

      <hr className="mt-0 mb-0 cs1 ce12" />
      <AnimateHeight
        id="extract-from-image-panel"
        duration={1000}
        height={shadeTintMode ? "auto" : 0}
        style={{ width: "334px" }}
        className="cs1 ce12"
        easing="cubic-bezier(0, 1, 0.5, 1)">
        <div className="cs1 ce12 grid">
          <div className="cs1 ce12  mt-4 mb-8">
            <div className="cs1 ce12">
              <div
                className="cs1 ce12"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  padding: "0px 0px",
                }}>
                {shadeTintColors.map((shadeTintColor, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: `${shadeTintColor}`,
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        outlineColor: "var(--indigo400)",
                        outlineWidth: "1px",
                        outlineStyle: "solid",
                        margin: "4px",
                      }}>
                      {/* {extractedColor} */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={addShadeTintColorsToPalette}
            className="cs1 ce12 button button-primary button-small">
            <span className="icon icon-plus mr-8 mb-2"></span>
            Add shades & tints to palette
          </button>
        </div>
      </AnimateHeight>
      <AnimateHeight
        id="extract-from-image-panel"
        duration={1000}
        height={extractingFromImageMode ? "auto" : 0}
        style={{ width: "334px" }}
        className="cs1 ce12"
        easing="cubic-bezier(0, 1, 0.5, 1)">
        <div className="cs1 ce12 grid">
          <div className="cs1 ce8  mt-4 mb-8">
            <ColorExtractor getColors={handleExtractColors}>
              <img src={url} style={{ width: 200, marginRight: "auto" }} />
            </ColorExtractor>
            <div className="cs1 ce12">
              <div
                className="cs1 ce6"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  maxWidth: "120",
                }}>
                {extractedColors.map((extractedColor, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: `${extractedColor}`,
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        outlineColor: "var(--indigo500)",
                        outlineWidth: "1px",
                        outlineStyle: "solid",
                        margin: "4px",
                      }}>
                      {/* {extractedColor} */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={addExtractedColorsToPalette}
            className="cs1 ce12 button button-primary button-small">
            <span className="icon icon-plus mr-8 mb-2"></span>
            Add colors to palette
          </button>
        </div>
      </AnimateHeight>

      <div className="cs1 ce12 grid mb-0">
        <AnimateHeight
          id="edit-color-panel"
          duration={1000}
          height={editMode ? "auto" : 0}
          className="cs1 ce12 grid mt--8"
          easing="cubic-bezier(0, 1, 0.5, 1)">
          <div className="cs1 ce12  mt-0 mb-16">
            <ColorPicker
              className=" mr-0 ml-0 pl-0 pr-0 mt-8 pt-0"
              value={color}
              hideControls={true}
              hidePresets={true}
              hideEyeDrop={true}
              width={334}
              height={334}
              hideAdvancedSliders={true}
              onChange={handleSetDotColorFromPalette}
            />
            <hr className="cs1 ce12 mt-16 mb-16" />
          </div>
          {/* <div className="cs1 ce12 grid mt-16">
            <div className="cs1 ce12 p-medium">
              <b>Advanced: </b> &nbsp; Import, extract, generate
            </div>
            <ToolTip
              placement={"top-start"}
              toolTipContent={"Import colors from board selection"}>
              <button
                onClick={importColorsFromBoard}
                className="cs1 ce4 button button-secondary pl-2 button-small  "
                type="button">
                <span className="icon-cursor-user smaller-button  ml-0"></span>
              </button>
            </ToolTip>
            <ToolTip
              placement={"top"}
              toolTipMaxWidth="60px"
              toolTipContent={"Extract colors from selected image asdasdf"}>
              <button
                onClick={extractFromImage}
                type="button"
                className="cs5 ce8 button button-secondary button-small">
                <span className="icon-image mb-2"></span>
              </button>
            </ToolTip>

            <ToolTip
              placement={"top-end"}
              toolTipContent={"Build palette from selected color in palette"}>
              <button
                type="button"
                className="cs9 ce12 mt--16  button button-secondary button-small">
                <span className="icon-settings mb-2"></span>
              </button>
            </ToolTip>
          </div> */}
        </AnimateHeight>
        <div className="cs1 ce12 grid mt--16">
          <div className="cs1 ce4 grid mr-0   pr-0 border-right">
            <p className="cs1 ce12 mb-0 mt--4 p-small">
              1 <b>selected</b> color:
            </p>
            <ToolTip
              placement={"top"}
              toolTipContent={
                "Fill the shape item(s) selected on the board with the color selected in PowerPack"
              }>
              <div className="cs1">
                <button
                  disabled={!canColorFillSomeSelectedItemsOnBoard}
                  onClick={() => fillItemsWithColor("single")}
                  className="cs1 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-1"
                  type="button">
                  <span className="icon-download smaller-button-icon"></span>
                </button>
              </div>
            </ToolTip>
            <ToolTip
              placement={"top"}
              toolTipContent={"Create new colored square(s)."}>
              <button
                onClick={() => addNewItemWithColor("single")}
                className="cs2 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-0"
                type="button">
                <span className="icon-plus smaller-button-icon"></span>
              </button>
            </ToolTip>
            <ToolTip
              placement={"top"}
              toolTipContent={
                "Duplicate the selected shape item, changing its color."
              }>
              <button
                disabled={!canCloneSingleSelectedItemOnBoard}
                onClick={() => duplicateItemAndFillWithColor("single")}
                className="cs3 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-4"
                type="button">
                <span className="icon-duplicate smaller-button-icon"></span>
              </button>
            </ToolTip>
          </div>
          <div className="cs5 ce12 grid">
            <p className="cs1 ce12 mb-0 mt--4 p-small">
              <b>All</b> colors:
            </p>
            <ToolTip
              placement={"top"}
              toolTipContent={"Fill the shape items selected on the board"}>
              <button
                disabled={!canColorFillSomeSelectedItemsOnBoard}
                onClick={() => fillItemsWithColor("all")}
                className="cs1 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-2"
                type="button">
                <span className="icon-download smaller-button-icon"></span>
              </button>
            </ToolTip>
            <ToolTip
              placement={"top"}
              toolTipContent={"Create new colored square(s)."}>
              <button
                onClick={() => addNewItemWithColor("all")}
                className="cs2 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-2"
                type="button">
                <span className="icon-plus smaller-button-icon"></span>
              </button>
            </ToolTip>
            <ToolTip
              placement={"top"}
              toolTipContent={
                "Duplicate the selected shape item, changing its color."
              }>
              <button
                disabled={!canCloneSingleSelectedItemOnBoard}
                onClick={() => duplicateItemAndFillWithColor("all")}
                className="cs3 button button-tertiary button-small smaller-button mb-0 mt-0 pt-0 pb-0 mr-0 pl-0 pr-0 ml-4"
                type="button">
                <span className="icon-duplicate smaller-button-icon"></span>
              </button>
            </ToolTip>
          </div>
        </div>
      </div>
    </div>
  );
}
